<div class="modal">
    <div class="header">
        <h1 class="title">{{'PREMIUM_TEAM_MEMBER_MODAL_ATTACH_ROLE' | translate}}</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(attachRolePending$ | async); else attachRoleNotPending">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #attachRoleNotPending>
            <div class="section">
                <h2 class="title-section">{{ 'PREMIUM_TEAM_MEMBER_MODAL_ATTACH_ROLE_SUBTITLE_ROLE' | translate }}</h2>
                <form class="form-section" [formGroup]="attachRoleForm" (ngSubmit)='onSubmit()'>
                    <div class="form-input" *ngIf="attributableRoles.length > 0">
                        <ng-select (click)="$event.stopPropagation()" [items]="attributableRoles" [searchable]="false" [clearable]="false"
                            placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAL_ATTACH_ROLE_PLACEHOLDER_ROLE' | translate }}" formControlName="role">
                            <ng-template ng-label-tmp let-item="item">
                                {{item?.name?.split('$')[1].toUpperCase() | translate}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name?.split('$')[1].toUpperCase() | translate}}
                            </ng-template>
                        </ng-select>
                    </div>
                </form>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()"
            [disabled]="(attachRolePending$ | async)">{{'PREMIUM_TEAM_MEMBER_MODAL_ATTACH_ROLE_BUTTON_LABEL_CANCEL' | translate}}</button>
        <button class="btn-new red" type="submit" (click)="onSubmit()"
            [disabled]="!attachRoleForm.valid || (attachRolePending$ | async)">{{'PREMIUM_TEAM_MEMBER_MODAL_ATTACH_ROLE_BUTTON_LABEL_ATTACH_ROLE'
            | translate}}</button>
    </div>
</div>